module.exports = __webpack_public_path__ + "img/workshop.a2cb9f41.png";